export default {
  user: {
    authenticate: false
  },
  area: null,
  loading: false,
  menu: [],
  collapsed: window.innerWidth <= 940,
  profile: null
};
